import { DeprecationsPlugin, PromisesPlugin, TemplateParamsPlugin, AliasSortingPlugin } from "/codebuild/output/src3082375315/src/codestar-connections.us-east-1.amazonaws.com/git-http/867915409343/us-east-1/9e561835-8a2f-4d1c-9907-8c0e7ae28d0b/geekcafe/geek-cafe-web-site/node_modules/@unhead/vue/dist/plugins.mjs";
export default {
  disableDefaults: true,
  disableCapoSorting: false,
  plugins: [DeprecationsPlugin, PromisesPlugin, TemplateParamsPlugin, AliasSortingPlugin],
}